import Vue from 'vue'
import Router from 'vue-router'

import store from '@/util/store'
import {config, user, whiteList} from '@/util/config'

Vue.use(Router)

console.log(config.meta.title); 

const router = new Router({
    mode: 'history',
    routes: [
      config,
      user
    ]
});


router.beforeEach((to, from, next) => {
    let skip = whiteList.indexOf(to.path);
    
    document.title = config.meta.title ? config.meta.title : "仝睿科技";

    if (skip != -1) {
        localStorage.clear();
        store.commit('setlogin', false);
        next();
    } else {
        let login = store.getters.isLogin();
        if (!login) {
            localStorage.clear();
            next('/user/login');
        } else {
            next();
        }
    }
});

export default router;
